import countryIcon from "../assets/countryIcon.svg";
import searchIcon from "../assets/searchIcon.svg";
import { useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import dropDownIcon from "../assets/dropdownIcon.svg";
import axios from "axios";
import CountryStore from "../store/CountryStore";
import CategoryStore from "../store/CategoryStore";
import { useLocation } from "react-router-dom";
import CityStore from "../store/CityStore";
import CategoryListStore from "../store/CategoryListStore";
import LoadingStore from "../store/LoadingStore";
import CityListStore from "../store/cityListStore";

function Searchbar({ setSelectedCity }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [categoryData, setCategoryData] = useState([]);
  const [countries, setCountries] = useState([]);
  const [resultCategory, setResultCategory] = useState("");
  const [countrySearch, setCountrySearch] = useState("");
  const setLoading = LoadingStore((state) => state.setLoading);

  const presentCountry = CountryStore((state) => state.country);
  const presentCategory = CategoryStore((state) => state.category);
  const presentCity = CityStore((state) => state.city);

  const setCountry = CountryStore((state) => state.setCountry);
  const setCategory = CategoryStore((state) => state.setCategory);
  const setCategoryList = CategoryListStore((state) => state.setCategoryList);
  const removeCityList = CityListStore((state) => state.removeCityList);

  const [isCountryDropdownVisible, setIsCountryDropdownVisible] =
    useState(false);
  const [isCategoryDropdownVisible, setIsCategoryDropdownVisible] =
    useState(false);

  const [selectedCountry, setSelectedCountry] = useState("Country");
  const [selectedCategory, setSelectedCategory] = useState(
    "What are you looking for?"
  );

  const countryDropdownRef = useRef(null);
  const categoryDropdownRef = useRef(null);
  const isFirstRender = useRef(true);

  // console.log(location.pathname);
  useEffect(() => {
    const formattedPresentCountry = presentCountry
      .replace(/\s+/g, "-")
      .toLowerCase();
    const formattedPresentCategory = presentCategory
      .replace(/\s+/g, "-")
      .toLowerCase();
    const formattedPresentCity = presentCity
      ?.replace(/\s+/g, "-")
      .toLowerCase();

    if (
      location.pathname ===
        `/${formattedPresentCountry}/${formattedPresentCategory}` ||
      location.pathname ===
        `/${formattedPresentCountry}/${formattedPresentCity}/${formattedPresentCategory}`
    ) {
      setSelectedCategory(
        presentCategory[0].toUpperCase() + presentCategory.slice(1)
      );
      setSelectedCountry(presentCountry);
    }
  }, [location.pathname, presentCountry, presentCategory, presentCity]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        countryDropdownRef.current &&
        !countryDropdownRef.current.contains(event.target)
      ) {
        setIsCountryDropdownVisible(false);
      }
      if (
        categoryDropdownRef.current &&
        !categoryDropdownRef.current.contains(event.target)
      ) {
        setIsCategoryDropdownVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // fetchCountryData function
  async function fetchCountryData() {
    setLoading(true);
    try {
      const response = await fetch("/api/get_sub_category.php", {
        method: "GET",
        mode: "cors", // 'no-cors' can be used but limits response handling
        headers: {
          "Content-Type": "application/json",
        },
      });

      const text = await response.text();
      // console.log('Raw response:', text);

      const cleanedText = text.replace(/[^{}[\],:\"\s0-9a-zA-Z]/g, "");
      // console.log('Cleaned response:', cleanedText);

      const parts = cleanedText.split("}{");
      // console.log('Split parts:', parts);

      const jsonParts = parts.map((part, index) => {
        if (index === 0) return part + "}";
        if (index === parts.length - 1) return "{" + part;
        return "{" + part + "}";
      });
      // console.log('JSON formatted parts:', jsonParts);

      try {
        const categoryData = JSON.parse(jsonParts[0]);
        const countryData = JSON.parse(jsonParts[1]);
        const responseCountData = JSON.parse(jsonParts[2]);

        // console.log('Parsed response count data:', responseCountData);

        // Handle category data
        if (categoryData.category && Array.isArray(categoryData.category)) {
          console.log(categoryData.category);
          setCategoryData(categoryData.category);
          const all = { id: "0", catname: "All", slug: "", caticon: null };
          setCategoryData((prevState) => [all, ...prevState]);

          // Updated to use responsecount instead of response_count
          if (responseCountData && responseCountData.responsecount) {
            // console.log('Setting category list with:', responseCountData.responsecount);
            setCategoryList(responseCountData.responsecount);
          } else {
            console.error("Response count data not found");
            setCategoryList({
              component: "",
              equipment: "",
              installer: "",
              material: "",
              panel: "",
              seller: "",
              software: "",
            });
          }
        }

        // Handle country data
        if (countryData.country && Array.isArray(countryData.country)) {
          const filteredCountries = countryData.country.filter((item) => {
            const name = item.countryname || "";
            return (
              /^[a-zA-Z\s]+$/.test(name.trim()) &&
              !name.startsWith("http") &&
              !name.startsWith("+") &&
              !name.startsWith("{")
            );
          });
          setCountries(filteredCountries.slice(1));
        } else {
          console.error("Country data not found");
          setCountries([]);
        }
      } catch (parseError) {
        console.error("Error parsing JSON parts:", parseError);
        setCategoryData([]);
        setCategoryList({
          component: "",
          equipment: "",
          installer: "",
          material: "",
          panel: "",
          seller: "",
          software: "",
        });
        setCountries([]);
      }
    } catch (e) {
      console.error("Error fetching or processing the response:", e);
      setCategoryData([]);
      setCategoryList({
        component: "",
        equipment: "",
        installer: "",
        material: "",
        panel: "",
        seller: "",
        software: "",
      });
      setCountries([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchCountryData();
  }, []);

  const toggleCountryDropdown = () => {
    setIsCountryDropdownVisible(!isCountryDropdownVisible);
    if (!isCountryDropdownVisible) {
      setCountrySearch("");
    }
  };
  const toggleCategoryDropdown = () =>
    setIsCategoryDropdownVisible(!isCategoryDropdownVisible);

  const filteredCountries = countries.filter((country) =>
    country.countryname.toLowerCase().startsWith(countrySearch.toLowerCase())
  );

  const handleCountrySelect = (countryName) => {
    console.log("called countryset: " + countryName);
    setSelectedCountry(countryName);
    const formattedPresentCountry = presentCountry
      .replace(/\s+/g, "-")
      .toLowerCase();
    const formattedPresentCategory = presentCategory
      .replace(/\s+/g, "-")
      .toLowerCase();
    const formattedPresentCity = presentCity
      ?.replace(/\s+/g, "-")
      .toLowerCase();
    if (
      location.pathname ===
        `/${formattedPresentCountry}/${formattedPresentCategory}` ||
      location.pathname ===
        `/${formattedPresentCountry}/${formattedPresentCategory}/${formattedPresentCity}`
    ) {
      setSelectedCity("");
    }
    setCountrySearch("");
    toggleCountryDropdown();
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    // Logic to control dropdown visibility based on state changes
    setIsCountryDropdownVisible(false); // Ensure dropdown closes on reload
    setIsCategoryDropdownVisible(false);
  }, [selectedCountry, selectedCategory]);

  const handleCategorySelect = (category_slug, category_name) => {
    setSelectedCategory(category_name);
    // setCategory(category_slug);
    setResultCategory(category_slug);
    toggleCategoryDropdown();
  };

  const handleSubmit = (selectedCountry, resultCategory) => {
    // console.log(resultCategory, selectedCountry);
    removeCityList();
    if (selectedCountry === "Country") {
      alert("Country needs to be selected");
      return;
    }
    if (selectedCategory !== "Country" && resultCategory === "All") {
      const formattedCountry = selectedCountry
        .replace(/\s+/g, "-")
        .toLowerCase();
      setCategory("");
      setCountry(selectedCountry);
      window.location.href = `/${formattedCountry}`;
      return;
    }
    setCountry(selectedCountry);
    setCategory(resultCategory);
    const formattedCountry = selectedCountry.replace(/\s+/g, "-").toLowerCase();
    const formattedCategory = resultCategory.replace(/\s+/g, "-").toLowerCase();
    // console.log(formattedCategory, formattedCountry);
    window.location.href = `/${formattedCountry}/${formattedCategory}`;
  };

  return (
    <div className="px-3 md:px-0 lg:px-16">
      <div
        className={`flex flex-col md:flex-row items-center border border-gray-300 py-2 px-2 rounded-md md:rounded-full text-[#6B7280] max-w-sm ${
          location.pathname === "/" ? "md:max-w-lg" : "md:max-w-auto"
        } lg:max-w-lg xl:max-w-2xl 2xl:max-w-3xl mx-auto`}
      >
        <div
          ref={countryDropdownRef}
          className="relative w-full mb-2 md:mb-0 md:w-52 lg:w-64"
        >
          <div
            onClick={toggleCountryDropdown}
            className="w-full flex items-center justify-between bg-white border border-gray-300 md:border-none py-2 px-3 rounded-md text-sm lg:text-base cursor-pointer"
          >
            <div className="flex items-center gap-2 sm:ml-1 w-full">
              <img
                src={countryIcon}
                alt="country icon"
                className="w-3 h-3 xl:w-4 xl:h-4"
              />
              {isCountryDropdownVisible ? (
                <input
                  type="text"
                  value={countrySearch}
                  onChange={(e) => setCountrySearch(e.target.value)}
                  placeholder="Search Country"
                  className="w-full outline-none text-sm lg:text-base 2xl:text-lg"
                  onClick={(e) => e.stopPropagation()}
                  autoFocus
                />
              ) : (
                <span
                  className={`${
                    selectedCountry.length > 15
                      ? "text-xs"
                      : "text-sm lg:text-base 2xl:text-lg"
                  } ${
                    selectedCountry === "Country"
                      ? "text-[#9CA3AF]"
                      : "text-black"
                  }`}
                >
                  {selectedCountry}
                </span>
              )}
            </div>
            <img
              src={dropDownIcon}
              alt="dropdown icon"
              className="w-2 h-2 lg:w-3 lg:h-3"
            />
          </div>
          {isCountryDropdownVisible && (
            <div
              className={`absolute z-10 left-0 right-0 ${
                location.pathname === "/" ? "md:left-8" : "md:left-4"
              } md:right-0 md:mt-2 bg-white border border-gray-300 rounded-md shadow-md max-h-40 overflow-y-auto`}
            >
              <ul className="">
                {countries
                  .filter((country) =>
                    country.countryname
                      .toLowerCase()
                      .startsWith(countrySearch.toLowerCase())
                  )
                  .map((country, index) => (
                    <li
                      key={index}
                      onClick={() => {
                        handleCountrySelect(country.countryname);
                        setCountrySearch(""); // Clear search when country is selected
                      }}
                      className="px-3 md:px-1 lg:px-2 xl:px-3 py-1 text-sm lg:text-sm 2xl:text-base border b-2 hover:bg-gray-100 hover:text-black cursor-pointer"
                    >
                      {country.countryname}
                    </li>
                  ))}
                {countries.filter((country) =>
                  country.countryname
                    .toLowerCase()
                    .startsWith(countrySearch.toLowerCase())
                ).length === 0 && (
                  <li className="px-3 py-2 text-sm text-gray-500 text-center">
                    No countries found
                  </li>
                )}
              </ul>
            </div>
          )}
        </div>

        <div className="hidden md:block bg-[#B0B8C1] py-4 px-[0.5px] md:mx-1 xl:mx-2"></div>

        <div
          ref={categoryDropdownRef}
          className={`relative w-full mb-2 md:mb-0 ${
            location.pathname === "/" ? "md:w-64" : "md:w-44"
          } lg:w-96`}
        >
          <button
            onClick={toggleCategoryDropdown}
            className="w-full flex items-center justify-between bg-white border border-gray-300 md:border-none py-2 px-3 pr-0 rounded-md text-sm lg:text-base"
          >
            <div className="flex items-center gap-2">
              <img
                src={searchIcon}
                alt="category icon"
                className="w-4 h-4 sm:w-3 sm:h-3 xl:w-4 xl:h-4"
              />
              {location.pathname === "/" ? (
                <span
                  className={`text-sm lg:text-base pr-3 truncate xl:ml-1 2xl:text-lg ${
                    selectedCategory === "What are you looking for?"
                      ? "text-[#9CA3AF]"
                      : "text-black"
                  }`}
                >
                  {selectedCategory}
                </span>
              ) : (
                <div>
                  <span
                    className={`inline md:hidden lg:inline text-[#9CA3AF] ${
                      selectedCategory === "What are you looking for?"
                        ? "text-[#9CA3AF]"
                        : "text-black"
                    }`}
                  >
                    {selectedCategory || "What are you looking for?"}
                  </span>
                  <span
                    className={`hidden md:inline lg:hidden text-[#9CA3AF] ${
                      selectedCategory === "What are you looking for?"
                        ? "text-[#9CA3AF]"
                        : "text-black"
                    }`}
                  >
                    {selectedCategory === "What are you looking for?"
                      ? "Category"
                      : selectedCategory}
                  </span>
                </div>
              )}
            </div>
          </button>
          {isCategoryDropdownVisible && (
            <div
              className={`absolute w-full ${
                location.pathname === "/" ? "md:w-44" : "md:w-[108px]"
              } lg:w-44 xl:w-52 md:left-6 lg:left-9 xl:left-9 z-10 md:mt-2 bg-white border border-gray-300 rounded-md shadow-md max-h-50 overflow-y-auto`}
              // style={{
              //   left: 'calc(24px + 0.5rem)',
              //   width: 'calc(100% - (24px + 1.5rem))'
              // }}
            >
              <ul className="">
                {categoryData.map((category, index) => (
                  <li
                    key={index}
                    onClick={() =>
                      handleCategorySelect(category.slug, category.catname)
                    }
                    className="px-3 lg:px-3 py-1 text-sm hover:bg-gray-100 hover:text-black cursor-pointer border-b-2"
                  >
                    {category.catname}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <div className="flex justify-center md:justify-end w-full md:w-auto md:ml-0 lg:ml-5 xl:ml-4">
          <button
            onClick={() => handleSubmit(selectedCountry, selectedCategory)}
            className={`w-full bg-[#006A4E] text-white rounded-md md:rounded-3xl text-sm lg:text-base py-2 px-3`}
          >
            Search
          </button>
        </div>
      </div>
    </div>
  );
}

export default Searchbar;
